import { render, staticRenderFns } from "./DeptTreePanel.vue?vue&type=template&id=604759d9&scoped=true"
import script from "./DeptTreePanel.vue?vue&type=script&lang=js"
export * from "./DeptTreePanel.vue?vue&type=script&lang=js"
import style0 from "./DeptTreePanel.vue?vue&type=style&index=0&id=604759d9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "604759d9",
  null
  
)

export default component.exports